class EligibilityGate extends HTMLElement {
  connectedCallback() {
    if (this.dataset.enabled !== 'true' || this.getCookie('windowok') === 'true') return;
    this.hidden = false;
    document.body.classList.add('eligibility-gate-open');
    this.confirm = this.querySelector('[data-gate-confirm]');
    this.decline = this.querySelector('[data-gate-decline]');
    this.confirm?.addEventListener('click', () => this.approve());
    this.decline?.addEventListener('click', () => window.location.assign(this.decline.dataset.redirect));
    this.addEventListener('keydown', (event) => this.trapFocus(event));
    this.confirm?.focus();
  }
  approve() {
    const seconds = Number(this.dataset.cookieDays) * 86400;
    document.cookie = `windowok=true; max-age=${seconds}; path=/; SameSite=Lax${location.protocol === 'https:' ? '; Secure' : ''}`;
    this.hidden = true;
    document.body.classList.remove('eligibility-gate-open');
  }
  getCookie(name) { return document.cookie.split('; ').find((row) => row.startsWith(`${name}=`))?.split('=')[1]; }
  trapFocus(event) {
    if (event.key !== 'Tab') return;
    const focusable = [...this.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])')];
    const first = focusable[0]; const last = focusable.at(-1);
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  }
}
customElements.define('eligibility-gate', EligibilityGate);
